import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CreateLinkDto, UpdateLinkDto } from '@klubovna/api-client';
import { LinksQueryParams } from '@adminServices';
import { Store } from '@ngrx/store';
import * as LinksActions from './links.actions';
import * as LinksSelectors from './links.selectors';

@Injectable({
  providedIn: 'root',
})
export class LinksFacade {
  private store = inject(Store);

  links$ = this.store.select(LinksSelectors.selectAllLinks);
  loading$ = this.store.select(LinksSelectors.selectLinksLoading);
  error$ = this.store.select(LinksSelectors.selectLinksError);
  pagination$ = this.store.select(LinksSelectors.selectLinksPagination);

  links = toSignal(this.links$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  loadLinks(params?: LinksQueryParams): void {
    this.store.dispatch(LinksActions.loadLinks({ params }));
  }

  createLink(linkData: CreateLinkDto): void {
    this.store.dispatch(LinksActions.createLink({ linkData }));
  }

  updateLink(id: string, linkData: UpdateLinkDto): void {
    this.store.dispatch(LinksActions.updateLink({ id, linkData }));
  }

  deleteLink(id: string): void {
    this.store.dispatch(LinksActions.deleteLink({ id }));
  }

  uploadImage(id: string, file: File): void {
    this.store.dispatch(LinksActions.uploadImage({ id, file }));
  }

  deleteImage(id: string): void {
    this.store.dispatch(LinksActions.deleteImage({ id }));
  }
}
